(function () {
  function getCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return 'BRL';
  }

  function formatPrice(cents) {
    var locale = document.documentElement.lang || 'pt-BR';
    try {
      return (cents / 100).toLocaleString(locale, {
        style: 'currency',
        currency: getCurrency()
      });
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function parseVariants(item) {
    var script = item.querySelector('product-form script[type="application/json"]');
    if (!script || !script.textContent) return [];
    try {
      var data = JSON.parse(script.textContent);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  function getVariantFromInputs(item, variants) {
    var options = {};
    item.querySelectorAll('.combo-variant-input input[type="radio"]:checked').forEach(function (input) {
      var position = parseInt(input.dataset.position, 10);
      if (!isNaN(position)) options[position] = input.value;
    });

    var entries = Object.entries(options);
    if (!entries.length) return null;

    return (
      variants.find(function (variant) {
        return entries.every(function (entry) {
          return variant['option' + entry[0]] === entry[1];
        });
      }) || null
    );
  }

  function getFirstAvailableVariant(variants) {
    if (!variants.length) return null;
    return (
      variants.find(function (variant) {
        return variant && variant.available;
      }) || variants[0]
    );
  }

  function setupCombo(combo) {
    if (combo.dataset.comboInitialized === 'true') return;
    combo.dataset.comboInitialized = 'true';

    var comboId = combo.dataset.comboId;
    var desconto = parseFloat(combo.dataset.desconto) || 0;
    var produtoItems = Array.prototype.slice.call(combo.querySelectorAll('.combo-product-item'));
    var totalElement = combo.querySelector('.price-total');
    var oldTotalElement = combo.querySelector('.old-total');
    var totalDataElement = combo.querySelector('.price-total-data');
    var addToCartButton = combo.querySelector('.add-bundle-to-cart');
    var errorWrapper = combo.querySelector('.combo-error-message');
    var errorMessage = combo.querySelector('.combo-error-text');

    var addToCartLabel = addToCartButton ? addToCartButton.innerHTML : '';
    var addingLabel = combo.dataset.addingLabel || 'Adding...';
    var unavailableMessage = combo.dataset.unavailableMessage || 'One or more products are unavailable';
    var addErrorMessage = combo.dataset.addErrorMessage || 'Unable to add products';
    var variantsByItem = produtoItems.map(parseVariants);
    var selectedVariants = [];

    function syncHiddenInput(item, variant) {
      var hiddenInput = item.querySelector('input[name="id"]');
      if (!hiddenInput || !variant) return;
      hiddenInput.value = variant.id;
      hiddenInput.removeAttribute('disabled');
    }

    function selectVariant(index) {
      var item = produtoItems[index];
      if (!item) return;

      var variants = variantsByItem[index];
      var variant = getVariantFromInputs(item, variants) || getFirstAvailableVariant(variants);

      selectedVariants[index] = variant;
      syncHiddenInput(item, variant);
    }

    function calculateTotal() {
      var originalTotal = 0;
      var allAvailable = produtoItems.length > 0;

      selectedVariants.forEach(function (variant) {
        if (!variant) {
          allAvailable = false;
          return;
        }
        if (!variant.available) allAvailable = false;
        originalTotal += variant.price;
      });

      var finalPrice = originalTotal;

      if (desconto > 0) {
        var firstPrice = selectedVariants[0] ? selectedVariants[0].price : 0;
        var secondPrice = selectedVariants[1] ? selectedVariants[1].price : 0;
        finalPrice = firstPrice + Math.round((secondPrice * (100 - desconto)) / 100);
      }

      if (oldTotalElement) {
        if (desconto > 0) {
          oldTotalElement.textContent = formatPrice(originalTotal);
          oldTotalElement.style.display = '';
        } else {
          oldTotalElement.style.display = 'none';
        }
      }

      if (totalElement) totalElement.textContent = formatPrice(finalPrice);

      if (totalDataElement) {
        totalDataElement.dataset.totalCents = finalPrice;
        totalDataElement.dataset.total = (finalPrice / 100).toFixed(2);
      }

      if (addToCartButton) addToCartButton.disabled = !allAvailable;
    }

    function showError(message) {
      if (!errorWrapper || !errorMessage) return;
      errorMessage.textContent = message;
      errorWrapper.hidden = false;
      setTimeout(function () {
        errorWrapper.hidden = true;
      }, 5000);
    }

    function resetButton() {
      if (!addToCartButton) return;
      addToCartButton.removeAttribute('disabled');
      addToCartButton.classList.remove('loading');
      addToCartButton.classList.remove('is-loading');
      addToCartButton.innerHTML = addToCartLabel;
    }

    function openCartAfterAdd() {
      if (typeof cartDrawerEnable !== 'undefined' && cartDrawerEnable && typeof buildCart === 'function' && typeof jQuery !== 'undefined') {
        if (typeof preLoadLoadGif !== 'undefined') {
          jQuery('[data-drawer-body]').html(preLoadLoadGif);
        }
        jQuery('body')
          .find('[data-side-drawer]')
          .attr('class', 'yv_side_drawer_wrapper')
          .attr('id', 'mini__cart')
          .addClass('mini_cart');
        if (typeof cartTitleLabel !== 'undefined') {
          jQuery('body').find('[data-drawer-title]').html(cartTitleLabel);
        }
        jQuery('body').removeClass('quickview-open').addClass('side_Drawer_open');

        if (document.getElementById('addToCartAlert')) {
          document.getElementById('addToCartAlert').play();
        }
        if (typeof hapticFeedbackStatus !== 'undefined' && hapticFeedbackStatus && window.navigator.vibrate) {
          window.navigator.vibrate(500);
        }

        jQuery.getJSON(typeof cartUrl !== 'undefined' ? cartUrl : '/cart.js', function (cart) {
          buildCart(cart, true, addToCartButton ? jQuery(addToCartButton) : null);
          setTimeout(resetButton, 1000);
        });
        return;
      }

      window.location.href = typeof mainCartUrl !== 'undefined' ? mainCartUrl : '/cart';
    }

    function addBundleToCart() {
      var items = selectedVariants
        .filter(function (variant) {
          return variant && variant.id;
        })
        .map(function (variant) {
          return {
            id: variant.id,
            quantity: 1,
            properties: { _combo_id: comboId }
          };
        })
        .reverse();

      if (items.length !== produtoItems.length) {
        showError(unavailableMessage);
        return;
      }

      if (addToCartButton) {
        addToCartButton.setAttribute('disabled', 'disabled');
        addToCartButton.classList.add('loading');
        addToCartButton.classList.add('is-loading');
        addToCartButton.textContent = addingLabel;
      }

      var addUrl = typeof cartAddUrl !== 'undefined' ? cartAddUrl : '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || addErrorMessage);
            });
          }
          return response.json();
        })
        .then(function () {
          if (window.Shopify && window.Shopify.designMode) {
            resetButton();
            return;
          }
          openCartAfterAdd();
        })
        .catch(function (error) {
          showError(error.message || addErrorMessage);
          resetButton();
        });
    }

    combo.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches('.combo-variant-input input[type="radio"]')) return;

      var item = input.closest('.combo-product-item');
      if (!item) return;

      var index = produtoItems.indexOf(item);
      if (index === -1) return;

      selectVariant(index);
      calculateTotal();
    });

    if (addToCartButton) {
      addToCartButton.addEventListener('click', function (event) {
        event.preventDefault();
        addBundleToCart();
      });
    }

    produtoItems.forEach(function (item, index) {
      selectVariant(index);
    });

    calculateTotal();
  }

  function initCombos(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.combo-slide').forEach(setupCombo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCombos(document);
    });
  } else {
    initCombos(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCombos(event.target);
  });
})();
